import { FilterTripHistoryServiceProviderTypes } from '../../components/details-view/trip-history/types';
import CustomerDataInterface, {
    BookingStatusFilterEnum,
    IAuditCustomer,
    ICustomerBooking,
    ICustomerTrip,
    PrePaymentStateFilterEnum,
} from '../../models/customer-data.interface';
import { FilterTripHistoryPaymentState } from '../../utils/trip-invoice-utils';
import { SearchType } from './customer-slice';
import { FilterByDateRange } from './types';

export interface CustomerState {
    customer?: CustomerDataInterface;
    auditTrail?: {
        orgData: IAuditCustomer[];
        data: IAuditCustomer[];
        status: 'idle' | 'loading' | 'succeeded' | 'failed';
        filter: {
            auditChangedBy: {
                customer: boolean;
                support: boolean;
            }
        }
    }
    bookings?: {
        data: ICustomerBooking[];
        futureFilteredData: ICustomerBooking[];
        futurePresentationData: ICustomerBooking[];
        pastFilteredData: ICustomerBooking[];
        pastPresentationData: ICustomerBooking[];
        status: 'idle' | 'loading' | 'succeeded' | 'failed';
        filter: {
            dateRange?: FilterByDateRange,
            bookingStatus?: BookingStatusFilterEnum,
            prePaymentState?: PrePaymentStateFilterEnum,
        },
    },
    trips?: {
        data: ICustomerTrip[];
        filteredData: ICustomerTrip[];
        presentationData: ICustomerTrip[];
        status: 'idle' | 'loading' | 'succeeded' | 'failed';
        filter: {
            dateRange?: FilterByDateRange,
            paymentState?: FilterTripHistoryPaymentState,
            serviceProvider?: FilterTripHistoryServiceProviderTypes
        },
    },
    id?: string
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    search: {
        identifier: {
            value?: string,
            bookingId?: string,
            userInput?: string,

        };
        type: SearchType;
        result: CustomerDataInterface[];
    };
}

export const initialCustomerState: CustomerState = {
    customer: undefined,
    auditTrail: {
        orgData: [],
        data: [],
        status: 'idle',
        filter: {
            auditChangedBy: {
                customer: false,
                support: false,
            }
        }
    },
    bookings: {
        data: [],
        futureFilteredData: [],
        futurePresentationData: [],
        pastFilteredData: [],
        pastPresentationData: [],
        status: 'idle',
        filter: {}
    },
    trips: {
        data: [],
        filteredData: [],
        presentationData: [],
        status: 'idle',
        filter: {}
    },
    id: undefined,
    search: {
        identifier: undefined,
        type: undefined,
        result: undefined,
    },
    status: 'idle',
};
